import React from "react";
import { CardList } from "@panda0/panda0-ui";

// Analytics Card
const AnalyticsCard = ({ cardHeader, cardDescription }) => (
  <CardList.Card
    innerClassName="flex"
    outerClassName="h-[90px] w-full flex items-center justify-between rounded-[10px] p-2"
  >
    <div className="ml-[20px] p-0 flex-grow">
      <h2 className="text-lg font-bold leading-none sm:text-3xl">
        {cardHeader}
      </h2>
      <h3 className="text-xs text-muted-foreground">{cardDescription}</h3>
      {/* <p className="text-sm font-bold leading-none sm:text-3xl">{CardFooter}</p> */}
    </div>
    {/* {CardDescription !== "Average Score" && (
      <div className="flex items-center mr-4">
        <TrendingUp />
      </div>
    )} */}
  </CardList.Card>
);

export default React.memo(AnalyticsCard);
